import React from 'react';
import RadialChart from 'components/common/RadialChart';
import { convertSVGIconToImageUri } from '@monorepo/shared/src/util/svg-util';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

type ProgressChartProps = {
  progress: number;
  color: string;
  icon: IconDefinition;
};

const ProgressChart: React.FC<ProgressChartProps> = ({ progress, color, icon }) => {
  return (
    <RadialChart
      height={120}
      width={120}
      series={[progress]}
      options={{
        colors: [color],
        grid: {
          padding: { top: -25, right: -5, bottom: -27, left: -25 },
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '45%',
              image: convertSVGIconToImageUri(icon, color),
              imageWidth: 20,
              imageHeight: 20,
              imageClipped: false,
              imageOffsetY: -12,
            },
            dataLabels: {
              name: { show: false },
              total: { show: false },
              value: {
                show: true,
                offsetY: 18,
                fontSize: '18px',
                fontWeight: 500,
              },
            },
          },
        },
      }}
    />
  );
};

export default ProgressChart;
